/* eslint-disable @typescript-eslint/no-unused-vars, react-hooks/exhaustive-deps, import/no-anonymous-default-export, no-useless-escape */
import api from '../services/api';
import React,{useState,useEffect} from 'react';
import Layout from '../components/layout/Layout';
import StatCard from '../components/common/StatCard';
import SlidePanel from '../components/common/SlidePanel';
import {Input,Select} from '../components/common/FormField';
import {fmtDateTime} from '../utils/helpers';

const BASE=process.env.REACT_APP_API_URL
const af=(p:string,o:any={})=>fetch(`${BASE}${p}`,{...o,headers:{...o.headers,Authorization:`Bearer ${localStorage.getItem('accessToken')}`,'Content-Type':'application/json'}}).then(r=>r.json());

export default function NABHPage(){
  const [tab,setTab]=useState<'compliance'|'indicators'|'audit'|'goals'>('compliance');
  const [summary,setSummary]=useState<any>({});
  const [checklists,setChecklists]=useState<any[]>([]);
  const [indicators,setIndicators]=useState<any[]>([]);
  const [auditLogs,setAuditLogs]=useState<any[]>([]);
  const [auditStats,setAuditStats]=useState<any>({});
  const [loading,setLoading]=useState(false);
  const [filterChapter,setFilterChapter]=useState('');
  const [filterStatus,setFilterStatus]=useState('');
  const [selectedItem,setSelectedItem]=useState<any>(null);
  const [showUpdate,setShowUpdate]=useState(false);
  const [updateForm,setUpdateForm]=useState<any>({status:'COMPLIANT',findings:'',correctiveAction:'',score:5,
    responsiblePerson:'',targetDate:'',intent:'',measurableElements:'',
    evidence:'',assessedBy:'',assessedAt:'',complianceScore:'',
    remarks:'',correctionPlan:''});
  const [saving,setSaving]=useState(false);
  const [msg,setMsg]=useState('');

  const load=async()=>{
    setLoading(true);
    try{
      const[s,c,i,al,as]=await Promise.all([
        af('/nabh/compliance/summary'),
        af(`/nabh/compliance/checklist?chapter=${filterChapter}&status=${filterStatus}`),
        af('/nabh/indicators/dashboard'),
        af('/nabh/audit?limit=50'),
        af('/nabh/audit/stats'),
      ]);
      setSummary(s.data||s||{});setChecklists(c.data||c||[]);setIndicators(i.data||i||[]);
      setAuditLogs(al.data?.logs||al.logs||[]);setAuditStats(as.data||as||{});
    }catch{}finally{setLoading(false);}
  };
  useEffect(()=>{load();},[filterChapter,filterStatus]);

  const updateChecklist=async()=>{
    if(!selectedItem)return;setSaving(true);
    try{
      await af(`/nabh/compliance/checklist/${selectedItem.id}`,{method:'PUT',body:JSON.stringify(updateForm)});
      setMsg('Assessment updated!');setShowUpdate(false);load();
    }catch(e:any){setMsg('Error: '+e.message);}
    finally{setSaving(false);setTimeout(()=>setMsg(''),3000);}
  };

  const CHAPTERS=['AAC','COP','MOM','IPSG','FMS','HRM','QPS'];
  const STATUS_COLOR:Record<string,string>={COMPLIANT:'text-green-600 bg-green-50',PARTIAL:'text-amber-600 bg-amber-50',NON_COMPLIANT:'text-red-600 bg-red-50',NOT_ASSESSED:'text-slate-500 bg-slate-50'};
  const STATUS_ICON:Record<string,string>={COMPLIANT:'✅',PARTIAL:'🔶',NON_COMPLIANT:'❌',NOT_ASSESSED:'⬜'};

  const complianceScore=summary.score||0;
  const scoreColor=complianceScore>=80?'text-green-600':complianceScore>=60?'text-amber-600':'text-red-600';

  return(
    <Layout title="NABH Quality & Compliance">
      {msg&&<div className={`mb-4 p-3 rounded-lg text-sm border ${msg.includes('!')?'bg-green-50 text-green-700 border-green-200':'bg-red-50 text-red-700 border-red-200'}`}>{msg}</div>}

      {/* Score Banner */}
      <div className="card p-5 mb-5 bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-100">
        <div className="flex items-center justify-between flex-wrap gap-4">
          <div>
            <p className="text-slate-500 text-sm">Overall NABH Compliance Score</p>
            <div className="flex items-end gap-3 mt-1">
              <span className={`text-6xl font-black ${scoreColor}`}>{complianceScore}%</span>
              <div className="pb-2">
                <span className={`text-sm font-bold px-3 py-1 rounded-full ${complianceScore>=80?'bg-green-100 text-green-700':complianceScore>=60?'bg-amber-100 text-amber-700':'bg-red-100 text-red-700'}`}>
                  {complianceScore>=80?'🏆 Accreditation Ready':complianceScore>=60?'⚠️ Needs Improvement':'❌ Below Threshold'}
                </span>
              </div>
            </div>
            <div className="w-64 h-3 bg-slate-200 rounded-full mt-2 overflow-hidden">
              <div className={`h-3 rounded-full transition-all ${complianceScore>=80?'bg-green-500':complianceScore>=60?'bg-amber-500':'bg-red-500'}`} style={{width:`${complianceScore}%`}}/>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3 text-center">
            {[['Compliant',summary.compliant||0,'green'],['Partial',summary.partial||0,'amber'],['Non-Compliant',summary.nonCompliant||0,'red'],['Not Assessed',summary.notAssessed||0,'slate']].map(([l,v,c])=>(
              <div key={l} className={`px-4 py-2 rounded-lg bg-${c}-50 border border-${c}-100`}>
                <p className={`text-xl font-bold text-${c}-600`}>{v as number}</p>
                <p className={`text-xs text-${c}-600 font-medium`}>{l}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="flex gap-2 mb-5">
        {[['compliance','📋 NABH Standards'],['indicators','📊 Quality Indicators'],['audit','🔍 Audit Trail'],['goals','🎯 Patient Safety Goals']].map(([t,l])=>(
          <button key={t} onClick={()=>setTab(t as any)} className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${tab===t?'bg-[#02357A] text-white shadow':'bg-white border border-slate-200 text-slate-600 hover:bg-slate-50'}`}>{l}</button>
        ))}
      </div>

      {tab==='compliance'&&(
        <div className="space-y-4">
          {/* Filters */}
          <div className="card p-4 flex flex-wrap gap-3">
            <div className="flex gap-2 flex-wrap">
              <button onClick={()=>setFilterChapter('')} className={`px-3 py-1.5 rounded-lg text-xs font-medium border transition-all ${!filterChapter?'bg-[#02357A] text-white border-[#015CA6]':'bg-white border-slate-200 text-slate-600'}`}>All Chapters</button>
              {CHAPTERS.map(ch=><button key={ch} onClick={()=>setFilterChapter(ch===filterChapter?'':ch)} className={`px-3 py-1.5 rounded-lg text-xs font-medium border transition-all ${filterChapter===ch?'bg-[#02357A] text-white border-[#015CA6]':'bg-white border-slate-200 text-slate-600'}`}>{ch}</button>)}
            </div>
            <div className="flex gap-2 ml-auto">
              {['NOT_ASSESSED','NON_COMPLIANT','PARTIAL','COMPLIANT'].map(s=>(
                <button key={s} onClick={()=>setFilterStatus(s===filterStatus?'':s)} className={`px-2 py-1 rounded text-xs font-medium border transition-all ${filterStatus===s?'ring-2 ring-blue-400':''} ${STATUS_COLOR[s]||'bg-gray-50'}`}>{STATUS_ICON[s]} {s.replace('_',' ')}</button>
              ))}
            </div>
          </div>

          {/* Standards List */}
          <div className="space-y-2">
            {loading?<div className="card p-8 text-center"><div className="w-8 h-8 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin mx-auto"/></div>:
            checklists.length===0?<div className="card p-8 text-center"><span className="text-4xl block mb-3">📋</span><p className="text-slate-500">No standards found. Import NABH checklist to get started.</p></div>:
            checklists.map((item:any)=>(
              <div key={item.id} className={`card p-4 border-l-4 hover:shadow-md transition-all cursor-pointer ${item.status==='COMPLIANT'?'border-l-green-500':item.status==='PARTIAL'?'border-l-amber-500':item.status==='NON_COMPLIANT'?'border-l-red-500':'border-l-slate-300'}`}
                onClick={()=>{setSelectedItem(item);setUpdateForm({status:item.status,findings:item.findings||'',correctiveAction:item.correctiveAction||'',score:item.score||5,responsiblePerson:item.responsiblePerson||'',targetDate:item.targetDate||''});setShowUpdate(true);}}>
                <div className="flex items-start justify-between gap-3">
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="font-mono font-black text-sm text-[#02357A] bg-blue-50 px-2 py-0.5 rounded">{item.standardCode}</span>
                      <span className="text-xs text-slate-400">{item.chapterCode} — {item.chapterTitle}</span>
                    </div>
                    <p className="text-sm text-slate-700 font-medium">{item.standard}</p>
                    {item.findings&&<p className="text-xs text-slate-500 mt-1 truncate">📝 {item.findings}</p>}
                    {item.correctiveAction&&<p className="text-xs text-amber-600 mt-0.5 truncate">⚡ Action: {item.correctiveAction}</p>}
                  </div>
                  <div className="flex flex-col items-end gap-1 flex-shrink-0">
                    <span className={`text-xs font-bold px-2 py-1 rounded-full ${STATUS_COLOR[item.status]}`}>{STATUS_ICON[item.status]} {item.status?.replace('_',' ')}</span>
                    {item.score!==null&&item.score!==undefined&&<span className="text-xs text-slate-400">Score: {item.score}/5</span>}
                    {item.targetDate&&<span className="text-xs text-red-500">Due: {new Date(item.targetDate).toLocaleDateString('en-IN')}</span>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {tab==='indicators'&&(
        <div className="space-y-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
            {indicators.map((ind:any)=>(
              <div key={ind.id} className="card p-4 hover:shadow-md transition-all">
                <div className="flex items-start justify-between mb-2">
                  <div><span className="font-mono text-xs text-[#02357A] bg-blue-50 px-2 py-0.5 rounded font-bold">{ind.indicatorCode}</span><p className="font-semibold text-slate-700 text-sm mt-1">{ind.indicatorName}</p></div>
                  {ind.onTarget!==null&&<span className={`text-xs font-bold px-2 py-1 rounded-full ${ind.onTarget?'bg-green-100 text-green-700':'bg-red-100 text-red-700'}`}>{ind.onTarget?'✅ On Target':'❌ Off Target'}</span>}
                </div>
                <div className="grid grid-cols-3 gap-2 text-center mt-3">
                  <div className="bg-slate-50 rounded-lg p-2"><p className="text-lg font-bold text-[#02357A]">{ind.latestData?.rate?.toFixed(1)||'—'}</p><p className="text-xs text-slate-400">{ind.unit||'rate'}</p><p className="text-xs text-slate-500">Current</p></div>
                  <div className="bg-slate-50 rounded-lg p-2"><p className="text-lg font-bold text-green-600">{ind.target||'—'}</p><p className="text-xs text-slate-400">{ind.unit||'rate'}</p><p className="text-xs text-slate-500">Target</p></div>
                  <div className="bg-slate-50 rounded-lg p-2"><p className="text-lg font-bold text-amber-600">{ind.benchmark||'—'}</p><p className="text-xs text-slate-400">{ind.unit||'rate'}</p><p className="text-xs text-slate-500">Benchmark</p></div>
                </div>
                <div className="flex items-center justify-between mt-3 text-xs text-slate-400">
                  <span className="bg-slate-100 px-2 py-0.5 rounded">{ind.category}</span>
                  <span>{ind.frequency}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {tab==='audit'&&(
        <div className="space-y-4">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="card p-4 text-center"><p className="text-2xl font-bold text-[#02357A]">{auditStats.todayLogs||0}</p><p className="text-sm text-slate-500">Today's Actions</p></div>
            <div className="card p-4 text-center"><p className="text-2xl font-bold text-red-600">{auditStats.failures||0}</p><p className="text-sm text-slate-500">Failed Actions</p></div>
            {(auditStats.byModule||[]).slice(0,2).map((m:any)=>(
              <div key={m.module} className="card p-4 text-center"><p className="text-2xl font-bold text-purple-600">{m.count}</p><p className="text-sm text-slate-500">{m.module}</p></div>
            ))}
          </div>
          <div className="card overflow-hidden">
            <div className="p-4 border-b flex justify-between items-center">
              <h3 className="font-semibold text-slate-700">Activity Audit Log</h3>
              <div className="flex gap-2">
                {['CREATE','UPDATE','DELETE','LOGIN','PRINT'].map(a=>(
                  <span key={a} className="text-xs bg-slate-100 text-slate-600 px-2 py-0.5 rounded cursor-pointer hover:bg-slate-200">{a}</span>
                ))}
              </div>
            </div>
            <div className="max-h-96 overflow-y-auto divide-y divide-slate-100">
              {auditLogs.length===0?<div className="p-8 text-center text-slate-500 text-sm">No audit logs found</div>:
              auditLogs.map((log:any,i:number)=>(
                <div key={i} className="px-4 py-3 hover:bg-slate-50 flex items-start gap-3">
                  <div className={`w-2 h-2 rounded-full mt-1.5 flex-shrink-0 ${log.outcome==='FAILURE'?'bg-red-500':log.action==='DELETE'?'bg-red-400':log.action==='LOGIN'?'bg-green-500':'bg-blue-400'}`}/>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className={`text-xs font-bold px-1.5 py-0.5 rounded ${log.action==='DELETE'?'bg-red-100 text-red-700':log.action==='CREATE'?'bg-green-100 text-green-700':log.action==='LOGIN'?'bg-blue-100 text-[#02357A]':'bg-slate-100 text-slate-700'}`}>{log.action}</span>
                      <span className="text-xs text-slate-600">{log.entityType} {log.entityName&&`— ${log.entityName}`}</span>
                      <span className="text-xs text-slate-400">{log.userEmail||log.userRole}</span>
                    </div>
                    {log.description&&<p className="text-xs text-slate-500 mt-0.5 truncate">{log.description}</p>}
                  </div>
                  <span className="text-xs text-slate-400 flex-shrink-0">{fmtDateTime(log.createdAt)}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {tab==='goals'&&(
        <div className="space-y-4">
          <div className="card p-5">
            <h3 className="font-bold text-slate-800 mb-4">🎯 International Patient Safety Goals (IPSG)</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {[
                {num:1,title:'Identify Patients Correctly',desc:'Use at least two patient identifiers before any procedure',icon:'🆔',status:'COMPLIANT'},
                {num:2,title:'Improve Effective Communication',desc:'Implement read-back process for critical values and verbal orders',icon:'📢',status:'PARTIAL'},
                {num:3,title:'Safety of High Alert Medications',desc:'Separate storage and double-check for high-risk medications',icon:'💊',status:'COMPLIANT'},
                {num:4,title:'Ensure Correct-Site Surgery',desc:'Implement surgical safety checklist (WHO SSC)',icon:'🔪',status:'NOT_ASSESSED'},
                {num:5,title:'Reduce Risk of Healthcare-Associated Infections',desc:'Implement hand hygiene guidelines',icon:'🧼',status:'COMPLIANT'},
                {num:6,title:'Reduce Risk of Patient Falls',desc:'Implement fall risk assessment and prevention program',icon:'🛡️',status:'PARTIAL'},
              ].map(g=>{
                const sc:Record<string,string>={COMPLIANT:'border-green-300 bg-green-50',PARTIAL:'border-amber-300 bg-amber-50',NON_COMPLIANT:'border-red-300 bg-red-50',NOT_ASSESSED:'border-slate-200 bg-slate-50'};
                const tc:Record<string,string>={COMPLIANT:'text-green-700',PARTIAL:'text-amber-700',NON_COMPLIANT:'text-red-700',NOT_ASSESSED:'text-slate-500'};
                return(
                  <div key={g.num} className={`p-4 rounded-xl border-2 ${sc[g.status]}`}>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-full bg-white border-2 border-current flex items-center justify-center font-black text-lg flex-shrink-0" style={{borderColor:'currentColor'}}>{g.num}</div>
                      <div className="flex-1">
                        <div className="flex items-center gap-2 mb-1">
                          <span className="text-lg">{g.icon}</span>
                          <h4 className="font-bold text-slate-800 text-sm">{g.title}</h4>
                        </div>
                        <p className="text-xs text-slate-600 mb-2">{g.desc}</p>
                        <span className={`text-xs font-bold ${tc[g.status]}`}>{STATUS_ICON[g.status]} {g.status.replace('_',' ')}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="card p-5">
            <h3 className="font-bold text-slate-800 mb-3">📋 NABH Accreditation Chapters</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              {[['AAC','Access, Assessment & Continuity'],['COP','Care of Patients'],['MOM','Management of Medication'],['PFR','Patient & Family Rights'],['HIC','Hospital Infection Control'],['FMS','Facility Management & Safety'],['HRM','Human Resource Management'],['QPS','Quality & Patient Safety']].map(([code,title])=>{
                const ch=summary.byChapter?.find((c:any)=>c.chapter===code);
                const pct=ch?Math.round((+ch.compliant/+ch.total)*100):0;
                return(
                  <div key={code} className="bg-slate-50 rounded-xl p-3 text-center">
                    <p className="font-mono font-black text-[#02357A] text-sm">{code}</p>
                    <p className="text-xs text-slate-500 mt-0.5 mb-2 leading-tight">{title}</p>
                    <div className="w-full bg-slate-200 rounded-full h-1.5 mb-1"><div className={`h-1.5 rounded-full ${pct>=80?'bg-green-500':pct>=60?'bg-amber-500':'bg-red-400'}`} style={{width:`${pct}%`}}/></div>
                    <p className="text-xs font-bold text-slate-600">{pct}%</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* Update Modal */}
      <SlidePanel isOpen={showUpdate} onClose={()=>setShowUpdate(false)} title={`Update Assessment — ${selectedItem?.standardCode}`} size="md">
        {selectedItem&&(
          <div>
            <div className="mb-4 p-3 bg-slate-50 rounded-lg">
              <p className="text-xs text-slate-400">{selectedItem.chapterCode} — {selectedItem.chapterTitle}</p>
              <p className="text-sm text-slate-700 mt-0.5 font-medium">{selectedItem.standard}</p>
            </div>
            <div className="space-y-3 mb-4">
              <div>
                <label className="label">Compliance Status *</label>
                <div className="grid grid-cols-2 gap-2">
                  {['COMPLIANT','PARTIAL','NON_COMPLIANT','NOT_ASSESSED'].map(s=>(
                    <button key={s} onClick={()=>setUpdateForm({...updateForm,status:s})} className={`py-2 px-3 rounded-lg text-xs font-bold border-2 transition-all ${updateForm.status===s?'ring-2 ring-blue-400':''} ${STATUS_COLOR[s]}`}>{STATUS_ICON[s]} {s.replace('_',' ')}</button>
                  ))}
                </div>
              </div>
              <div>
                <label className="label">Score (0-5)</label>
                <div className="flex gap-2">
                  {[0,1,2,3,4,5].map(n=><button key={n} onClick={()=>setUpdateForm({...updateForm,score:n})} className={`w-10 h-10 rounded-lg font-bold text-sm border-2 transition-all ${updateForm.score===n?'bg-[#02357A] text-white border-[#015CA6]':'border-slate-200 text-slate-600 hover:bg-slate-50'}`}>{n}</button>)}
                </div>
              </div>
              <div><label className="label">Findings / Observations</label><textarea className="input" rows={3} value={updateForm.findings} onChange={e=>setUpdateForm({...updateForm,findings:e.target.value})} placeholder="Document your findings..."/></div>
              <div><label className="label">Corrective Action Required</label><textarea className="input" rows={2} value={updateForm.correctiveAction} onChange={e=>setUpdateForm({...updateForm,correctiveAction:e.target.value})} placeholder="Action plan..."/></div>
              <div className="grid grid-cols-2 gap-3">
                <div><label className="label">Responsible Person</label><Input value={updateForm.responsiblePerson} onChange={e=>setUpdateForm({...updateForm,responsiblePerson:e.target.value})} placeholder="Name"/></div>
                <div><label className="label">Target Date</label><Input type="date" value={updateForm.targetDate} onChange={e=>setUpdateForm({...updateForm,targetDate:e.target.value})}/></div>
              </div>
            </div>
            <div className="flex gap-3">
              <button onClick={updateChecklist} disabled={saving} className="btn-primary flex-1">{saving?'Saving...':'Save Assessment'}</button>
              <button onClick={()=>setShowUpdate(false)} className="btn-secondary">Cancel</button>
            </div>
          </div>
        )}
      </SlidePanel>
    </Layout>
  );
}
